export default __webpack_public_path__ + "static/media/investments-tile-3.066ddaf2.png";